import React from 'react';
import PropTypes from 'prop-types';

import {
  ErrorMessage,
  Spinner,
} from '../../base';

import { Grid, Cell } from '../../base/styled';

import { ReactTableWidget } from '../../widgets';

const ServiceComponents = (props) => {

  const {
    title = '',
    subtitle = '',
    defaultPage = 0,
    defaultSortColumnId = null,
    defaultSortDescending = false,
    table = {},
  } = props;

  if (!table) {
    return React.createElement(Spinner);
  }

  const { data = null, error = null } = table;
  if (error) {
    return React.createElement(ErrorMessage, { error });
  }
  if (!data) {
    return React.createElement(Spinner);
  }

  return (
    <div className="dashboard">
      <Grid
        columns={1}
        rows="30px 1fr 30px"
        alignContent="stretch"
      >
        <Cell>
          <div style={{ textAlign: 'center' }}>
            <div>{title}</div>
            <div>{subtitle}</div>
          </div>
        </Cell>
        <Cell>
          <div style={{
            height: 'inherit',
            overflow: 'auto',
          }}
          >
            <ReactTableWidget
              input={table}
              defaultPage={defaultPage}
              defaultSortColumnId={defaultSortColumnId}
              defaultSortDescending={defaultSortDescending}
            />
          </div>
        </Cell>
        <Cell>
          For more information regarding this data and how it is calculated, please search for &quot;Service Request (SR) Workflow and Metrics&quot; on the Wiki.
        </Cell>
      </Grid>
    </div>
  );
};

ServiceComponents.defaultProps = {
  title: '',
  subtitle: '',
  table: null,
  defaultPage: 0,
  defaultSortColumnId: null,
  defaultSortDescending: false,
};

ServiceComponents.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  table: PropTypes.shape(ReactTableWidget.propTypes),
  defaultPage: PropTypes.number,
  defaultSortColumnId: PropTypes.string,
  defaultSortDescending: PropTypes.bool,
};

export default ServiceComponents;
